import { createContext, useState, useEffect } from "react";

export const UserContext = createContext();

export function UserProvider({ children }) {
  const [loggedUser, setLoggedUser] = useState(null);

  // Prova a caricare l'utente salvato (es. dopo refresh)
  useEffect(() => {
    try {
      const stored = localStorage.getItem("loggedUser");
      if (stored) setLoggedUser(JSON.parse(stored));
    } catch {
      setLoggedUser(null);
    }
  }, []);

  // Ogni volta che cambia, salva su localStorage
  useEffect(() => {
    if (loggedUser) localStorage.setItem("loggedUser", JSON.stringify(loggedUser));
    else localStorage.removeItem("loggedUser");
  }, [loggedUser]);

  return (
    <UserContext.Provider value={{ loggedUser, setLoggedUser }}>
      {children}
    </UserContext.Provider>
  );
}
